var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChickenUserIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBAF4B"
    },
    d: "M201.01,401.558c-2.614-3.861-7.883-4.881-11.748-2.259l-57.953,39.261l-39.683-22.285 c-4.071-2.292-9.225-0.838-11.517,3.233c-2.288,4.071-0.838,9.229,3.233,11.517l66.362,37.267c1.309,0.735,2.734,1.082,4.133,1.082 c2.957,0,5.831-1.553,7.383-4.315c2.288-4.071,0.838-9.229-3.233-11.517l-10.185-5.72l50.95-34.516 C202.616,410.684,203.627,405.427,201.01,401.558z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBAF4B"
    },
    d: "M307.343,484.33l-9.563,0.001l-9.836-68.852c-0.657-4.625-4.93-7.808-9.568-7.173 c-4.621,0.661-7.833,4.943-7.173,9.568l9.494,66.458l-41.009,0.003c-4.67,0-8.457,3.787-8.457,8.457s3.787,8.457,8.457,8.457 l67.654-0.004c4.67,0,8.457-3.787,8.457-8.457C315.799,488.116,312.013,484.33,307.343,484.33z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDC64"
    },
    d: "M442.932,276.74c-73.35-9.441-174.468-55.018-177.83-146.817 c-2.303-62.886-50.419-116.407-113.291-119.062C100.127,8.679,55.386,39.646,37.092,84.257c-6.779,16.532-8.759,34.643-6.327,52.345 l2.297,16.722c2.383,17.35,9.067,33.885,19.743,47.766c0.092,0.12,0.185,0.24,0.278,0.36c3.434,4.43,5.215,9.938,5.12,15.543 c-1.836,108.171,75.506,216.725,217.631,216.725c109.004,0,201.676-64.482,235.516-153.878c3.034-8.015-5.096-15.661-12.929-12.184 C484.581,273.799,464.851,279.561,442.932,276.74z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC850"
    },
    d: "M335.031,423.148c-141.884,0-272.656-124.615-239.224-348.266 c3.825-25.588,19.351-48.5,37.709-63.373C89.319,16.401,52.447,45.592,36.61,85.452c-6.578,16.558-8.104,34.702-5.68,52.354 l1.901,13.835c2.471,17.994,9.065,35.347,20.178,49.713c0.093,0.12,0.186,0.24,0.279,0.359c3.497,4.485,4.989,10.142,4.906,15.829 c-1.565,107.989,75.756,216.175,217.64,216.175c26.783,0,52.492-4.073,76.672-11.271 C346.719,422.818,340.919,423.148,335.031,423.148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC850"
    },
    d: "M298.022,185.462c-29.739-23.499-71.661-21.593-100.601,2.883 c-110.138,93.147,93.021,279.838,252.417,72.882c4.633-6.016,1.399-14.807-6.012-16.455 C412.193,237.739,340.369,218.924,298.022,185.462z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EB914B"
    },
    d: "M25.882,126.482L2.395,146.44c-3.837,3.261-2.916,9.417,1.707,11.413l28.244,12.188 c3.618,1.561,7.754-0.26,9.104-3.962c3.247-8.907,6.45-25.239-6.048-38.974C32.928,124.384,28.684,124.1,25.882,126.482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBAF4B"
    },
    d: "M443.831,244.768c-7.653-1.703-17.657-4.095-29.022-7.214 c-67.473,101.387-199.174,123.442-243.908,40.644c27.128,77.121,164.339,131.84,278.951-16.99 C454.481,255.198,451.237,246.416,443.831,244.768z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4B3F4E"
    },
    d: "M104.397,146.059L104.397,146.059c-14.012,0-25.37-11.359-25.37-25.37v-8.457 c0-14.012,11.359-25.37,25.37-25.37l0,0c14.012,0,25.37,11.359,25.37,25.37v8.457C129.767,134.7,118.408,146.059,104.397,146.059z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D5360"
    },
    d: "M104.397,86.861v29.599c0,7.006,5.679,12.685,12.685,12.685s12.685-5.679,12.685-12.685v-4.228 C129.767,98.22,118.408,86.861,104.397,86.861z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 104.4,
    cy: 103.78,
    r: 8.457
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChickenUserIcon);
export default __webpack_public_path__ + "static/media/chicken-user-icon.a9e381266e7c2e8b92eaf9423e78367c.svg";
export { ForwardRef as ReactComponent };